import { useParams } from 'react-router-dom';

/**
 * Get VIN from route
 */
export const useVin = () => {
  const { vin } = useParams<any>();
  return vin;
};
